<template>
  <div class="">
    <div
      class="d-flex flex-column px-12 py-3 rounded-top bg-befriend justify-content-between align-items-center"
      style="width: 327px; height: 98px">
      <div class="mt-2 mb-1">
        <img
          style="width: 40px; height: 40px; border-radius: 20px"
          :src="currentAcc?.avatar || '/assets/images/no-avatar.png'" />
        <img
          class="z2-avatar"
          style="border: 2px solid #0075d4; margin-left: -0.75rem"
          :src="conversation?.avatar || thumb || '/assets/images/no-avatar.png'" />
      </div>

      <div class="d-flex font-size-16 fw-semibold">
        <span class="font-14 fw-500 text-white">
          Bạn và {{ conversation.swName && conversation.swName.length > 0 ? conversation.swName : conversation.toName }} trở thành bạn của nhau
        </span>
      </div>
    </div>
    <div
      class="font-12 fw-300 text-grey600 d-flex align-items-center justify-content-center rounded-bottom"
      style="height: 28px; background-color: white">
      Bắt đầu nhắn tin ngay để tạo những kỷ niệm đáng nhớ
    </div>
  </div>
</template>

<script>
export default {
  name: "ChatECard",
  props: ["thumb", "conversation"],
  computed: {
    currentAcc() {
      const currentAcc = this.app.accounts.find((a) => a.accountId === this.conversation.accountId);
      return currentAcc;
    },
  },
};
</script>

<style scoped>
.bg-befriend {
  background-image: url("/assets/images/bg-be-friend.png");
  background-size: contain;
}
</style>